export const SET_TECHS = 'SET_TECHS';
export const SET_LOADING_DASH = 'SET_LOADING_DASH';